import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IElmAssistSupportGroup } from '../interfaces/employee-lifecycle/elm-assist-support-group.interface';
import { IElmDistributionList } from '../interfaces/employee-lifecycle/elm-distribution-list.interface';
import { IElmHardwareOptionCategory } from '../interfaces/employee-lifecycle/elm-hardware-option-category.interface';
import { IElmMailbox } from '../interfaces/employee-lifecycle/elm-mailbox.interface';
import { IElmServiceLaneTaskType } from '../interfaces/employee-lifecycle/elm-service-lane-task-type.interface';
import { IElmServiceLane } from '../interfaces/employee-lifecycle/elm-service-lane.interface';

@Injectable({
  providedIn: 'root',
})
export class EmployeeLifecycleMetadataService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiUrl;

  public getHardwareOptions(): Observable<IElmHardwareOptionCategory[]> {
    return this.http.get<IElmHardwareOptionCategory[]>(`${this.baseUrl}ElmHardwareOptions/GetAll`);
  }

  public getAssistSupportGroups(): Observable<IElmAssistSupportGroup[]> {
    return this.http.get<IElmAssistSupportGroup[]>(`${this.baseUrl}ElmAssistSupportGroups/GetAll`);
  }

  public getMailboxes(): Observable<IElmMailbox[]> {
    return this.http.get<IElmMailbox[]>(`${this.baseUrl}ElmMailboxes/GetAll`);
  }

  public getDistributionLists(): Observable<IElmDistributionList[]> {
    return this.http.get<IElmDistributionList[]>(`${this.baseUrl}ElmDistributionLists/GetAll`);
  }

  public getServiceLanes(): Observable<IElmServiceLane[]> {
    return this.http.get<IElmServiceLane[]>(`${this.baseUrl}ElmServiceLanes/GetAll`);
  }

  public getServiceLaneTaskTypes(): Observable<IElmServiceLaneTaskType[]> {
    return this.http.get<IElmServiceLaneTaskType[]>(`${this.baseUrl}ElmServiceLaneTaskTypes/GetAll`);
  }
}
